




































import Vue from 'vue'
import UiSelectInput from '@/components/Ui/Inputs/SelectInput.vue'

export default Vue.extend({
  name: 'UiPagination',
  components: {UiSelectInput},
  props: ['pagination', 'documentsName', 'count', 'columnSelector', 'selectedColumns'],
  methods: {
    onColumnSelectorInput (event: string[]) {
      this.$emit('columnSelection', event)
    }
  },
  computed: {
    currentSelectedColumns: {
      get (): string[] {
        return this.selectedColumns
      },
      set () {

      }
    }
  }
})
